import * as React from 'react';
import './Crawler.scss';
export let LoadingIndicatorSize;

(function (LoadingIndicatorSize) {
  LoadingIndicatorSize["SMALL"] = "small";
  LoadingIndicatorSize["MEDIUM"] = "medium";
  LoadingIndicatorSize["LARGE"] = "large";
  LoadingIndicatorSize["DEFAULT"] = "default";
})(LoadingIndicatorSize || (LoadingIndicatorSize = {}));

const LoadingIndicator = (_ref) => {
  let {
    className = '',
    size = LoadingIndicatorSize.DEFAULT
  } = _ref;
  return React.createElement("div", {
    className: "crawler ".concat(className, " is-").concat(size)
  }, React.createElement("div", null), React.createElement("div", null), React.createElement("div", null));
};

export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map